module.exports = __webpack_public_path__ + "static/computer_d-0b411b3bb9e0cdd2b6b6ff1285e1efb2.svg";